import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { BrandLogo } from './BrandLogo';
import { trackHeaderCTA } from '../tracking';
import { scrollToModels } from '../utils/scroll';
import type { Language } from '../types/lead';
export function Header() {
  const {
    t,
    lang,
    setLang
  } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // "See my options" browses the models first — the lower-commitment step. Choosing
  // one pre-fills the form and scrolls there, so the lead is still captured.
  const handleCTA = () => {
    trackHeaderCTA();
    scrollToModels();
  };
  const languages: Language[] = ['en', 'es'];
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled ? 'border-b border-camel/30 bg-white/95 shadow-sm backdrop-blur-md' : 'border-b border-transparent bg-white/80 backdrop-blur-sm'}`} data-id="element-113" data-mp="3fcrnrdtb88lb">
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between gap-3 px-4 py-2 sm:px-6 sm:py-3" data-id="element-114" data-mp="2mm54j171byq1">
        {/* On mobile the wordmark stacks in two tight lines beside the monogram so the
            brand still reads, without pushing the toggle and CTA off the bar. */}
        <a href="#top" aria-label={t('nav.home')} className="flex items-center gap-2 font-display font-extrabold uppercase text-ink sm:gap-3" data-id="element-115" data-mp="3ac9avgblyckq">
          <BrandLogo tone="light" className="h-10 w-10 shrink-0 sm:h-16 sm:w-16" data-id="element-116" data-mp="35j6aopcbs4vk" />
          <span className="text-[9px] leading-[1.25] tracking-[0.14em] sm:hidden" data-id="element-117" data-mp="30m67cm6v1g85">
            MIAMI CAR
            <br data-id="element-118" data-mp="1yipu1177mfs" />
            QUEENS
          </span>
          <span className="hidden text-base leading-none tracking-[0.18em] sm:inline" data-id="element-119" data-mp="3tav6wgs9pdhs">
            MIAMI CAR QUEENS
          </span>
        </a>

        <div className="flex items-center gap-2 sm:gap-4" data-id="element-120" data-mp="1rfo1xoedkhfb">
          <div role="group" aria-label={t('nav.language')} className="flex items-center overflow-hidden border border-ink/25" data-id="element-121" data-mp="1wbmm0zso7d9x">
            {languages.map(code => <button key={code} type="button" onClick={() => setLang(code)} aria-pressed={lang === code} className={`min-h-[44px] px-2.5 text-[11px] font-bold uppercase leading-none tracking-[0.08em] transition-colors sm:px-3 sm:text-xs ${lang === code ? 'bg-ink text-white' : 'text-ink/60 hover:text-ink'}`} data-id="element-122" data-mp="1mla299sojo4u">
                {code}
              </button>)}
          </div>

          {/* Only ONE gold-filled CTA per viewport: while the hero (and its gold CTA)
              is on screen this stays an outline, and fills with gold after scrolling. */}
          <button type="button" onClick={handleCTA} className={`min-h-[44px] whitespace-nowrap px-3.5 text-[11px] font-bold uppercase leading-none tracking-[0.1em] transition-all sm:min-h-[48px] sm:px-5 sm:text-xs sm:tracking-[0.12em] ${scrolled ? 'bg-gold text-golddeep hover:-translate-y-[1px]' : 'border border-ink text-ink hover:bg-ink hover:text-white'}`} data-id="element-123" data-mp="mffz69g87192">
            <span className="sm:hidden" data-id="element-124" data-mp="106kxn87uxnht">{t('nav.ctaShort')}</span>
            <span className="hidden sm:inline" data-id="element-125" data-mp="108feaac3itg3">{t('nav.cta')}</span>
          </button>
        </div>
      </div>
    </header>;
}